import {Snackbar, withStyles, WithStyles, SnackbarContent} from '@material-ui/core';
import * as React from "react";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import InfoIcon from "@material-ui/icons/Info";
import {EcoAgreementStatus, IEcoAgreement, IEcoPurchase, IEcoTransfer} from "@app-types/websocket/economy.types";
import TranslateNew from "@translate/TranslateNew";
import {StackedNotificationsStyle as styles} from './StackedNotifications.style';


const tn = TranslateNew.getInstance();



interface IStackedNotificationsProps extends WithStyles<typeof styles> {
    agreementsThatNeedArchive: IEcoAgreement[];
    archiveAgreement: (agreementId: number) => void;
    archiveAgreementUpdate: (agreementId: number) => void;
    purchasesThatNeedSeen: IEcoPurchase[];
    seenPurchase: (purchaseId :number) => void;
    purchasesThatNeedArchive: IEcoPurchase[];
    archivePurchase: (purchaseId :number) => void;
    userId: number;
    transfersThatNeedSeen: IEcoTransfer[];
    transfersThatNeedArchive: IEcoTransfer[];
    archiveTransfer: (transferId:number) => void;
    seenTransfer: (transferId:number) => void;
    showTransfer: (transfer:IEcoTransfer) => void;
    showPurchase: (transfer:IEcoPurchase) => void;
    showAgreement: (transfer:IEcoAgreement) => void;
}

class StackedAgreementNotifications extends React.Component<IStackedNotificationsProps> {
    public render() {
        const {
            classes,
            agreementsThatNeedArchive,
            purchasesThatNeedSeen,
            purchasesThatNeedArchive,
            transfersThatNeedArchive,
            transfersThatNeedSeen,
            userId
        } = this.props;

        const snacks:JSX.Element[] = [];
        let index = 0;
        for (const agreement of agreementsThatNeedArchive) {
            let message = agreement.title;
            index++;
            if (agreement.pendingChange && agreement.pendingChange.status === EcoAgreementStatus.REJECTED 
                && !agreement.pendingChange.archivedBy.includes(userId)) {
                message = tn.lang.rejectPendingAgreement(agreement.title);
                snacks.push(this.snackbarContent(message, ""+index, 
                () => this.props.archiveAgreementUpdate(agreement.id), () => this.props.showAgreement(agreement)));
            } else if (agreement.pendingChange && agreement.pendingChange.status === EcoAgreementStatus.DELETED
                && !agreement.pendingChange.archivedBy.includes(userId)
            ) {
                message = tn.lang.deletePendingAgreement(agreement.title);
                snacks.push(this.snackbarContent(message, ""+index, 
                () => this.props.archiveAgreementUpdate(agreement.id), () => this.props.showAgreement(agreement)));
            } else if (agreement.status === EcoAgreementStatus.REJECTED) {
                message = tn.lang.rejectAgreement(agreement.title);
                snacks.push(this.snackbarContent(message, ""+index, 
                    () => this.props.archiveAgreement(agreement.id), () => this.props.showAgreement(agreement)));
            } else  if (agreement.status === EcoAgreementStatus.DELETED) {
                message = tn.lang.deleteAgreement(agreement.title);
                snacks.push(this.snackbarContent(message, ""+index, 
                    () => this.props.archiveAgreement(agreement.id), () => this.props.showAgreement(agreement)));
            }
        }
        for (const purchase of purchasesThatNeedSeen) {
            const message = tn.lang.unseenPurchase("("+tn.formatDateShort(new Date(purchase.date))+"): "+purchase.title);
            index++;
            snacks.push(this.snackbarContent(message, "p"+index, 
            () => this.props.seenPurchase(purchase.id), () => this.props.showPurchase(purchase)));
        }
        for (const purchase of purchasesThatNeedArchive) {
            const message = tn.lang.deletedPurchase("("+tn.formatDateShort(new Date(purchase.date))+"): "+purchase.title);
            index++;
            snacks.push(this.snackbarContent(message, "p"+index, 
            () => this.props.archivePurchase(purchase.id), () => this.props.showPurchase(purchase)));
        }
        for (const transfer of transfersThatNeedSeen) {
            const message = tn.lang.unseenTransfer(tn.formatDateShort(new Date(transfer.date)));
            index++;
            snacks.push(this.snackbarContent(message, "t"+index, 
            () => this.props.seenTransfer(transfer.id), () => this.props.showTransfer(transfer)));
        }
        for (const transfer of transfersThatNeedArchive) {
            const message = tn.lang.deletedTransfer(tn.formatDateShort(new Date(transfer.date)));
            index++;
            snacks.push(this.snackbarContent(message, "t"+index, 
            () => this.props.archiveTransfer(transfer.id), () => this.props.showTransfer(transfer)));
        }

        return (
            <Snackbar
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                }}
                open={snacks.length > 0}
                className={classes.container}
            >
                <div className={classes.innerContainer}>
                    {snacks}
                </div>
            </Snackbar>
        );
    }

    private snackbarContent(message:string, key:string, action:() => void, show:() => void) {
        return (
            <SnackbarContent
                className={this.props.classes.snackbar}
                key={key}
                message={message}
                action={[
                    <IconButton
                        key="info"
                        aria-label="Info"
                        color="inherit"
                        onClick={() => {action(); show();}}
                    >
                        <InfoIcon />
                    </IconButton>,
                    <IconButton
                        key="close"
                        aria-label="Close"
                        color="inherit"
                        onClick={action}
                    >
                        <CloseIcon />
                    </IconButton>
                ]}
            />
        );
    }
}

export default withStyles(styles)(StackedAgreementNotifications);



// WEBPACK FOOTER //
// ./src/components/economy/StackedNotifications.tsx